import { Injectable } from '@angular/core';
import { MarcheNegocie } from '../../models/MarcheNegocie';
import { Procedure } from '../../models/Procedure';
import { TypeOuiNon } from '../../models/TypeOuiNon';

@Injectable({
  providedIn: 'root'
})
export class ProcedureService {

  constructor() {
  }

  getProcedure(controls: any) {
    const procedure = new Procedure();
    procedure.appelOuvert = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Procedure_SepAtt_appelOuvert'));
    procedure.appelRestreint = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Procedure_SepAtt_appelRestreint'));
    procedure.autres = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Procedure_SepAtt_autres'));
    procedure.concoursOuvert = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Procedure_SepAtt_concoursOuvert'));
    procedure.concoursRestreint = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Procedure_SepAtt_concoursRestreint'));
    procedure.dialogueCompetitif = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Procedure_SepAtt_dialogueCompetitif'));
    procedure.marcheNegocie = new MarcheNegocie();
    procedure.marcheNegocie.candidatsDejaSelectionnes = new TypeOuiNon();
    procedure.marcheNegocie.candidatsDejaSelectionnes.non = controls.get('_SepSep_Initial_SepSep_Procedure_SepSep_MarcheNegocie_SepSep_TypeOuiNon_SepAtt_non');
    procedure.marcheNegocie.candidatsDejaSelectionnes.oui = controls.get('_SepSep_Initial_SepSep_Procedure_SepSep_MarcheNegocie_SepSep_TypeOuiNon_SepAtt_oui');
    procedure.procedureAdaptee = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Procedure_SepAtt_procedureAdaptee'));
    return procedure;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
